<div class="tablesaw-bar mode-swipe tablesaw-all-cols-visible">
	<div class="tablesaw-advance">
		<a href="#" class="tablesaw-nav-btn btn btn-micro left js-chart-axis" data-step="-1" data-chart="{{key}}"></a>
		<a href="#" class="tablesaw-nav-btn btn btn-micro right js-chart-axis" data-step="1" data-chart="{{key}}"></a>
	</div>
</div>
